import { blankNomination, Nomination } from './nomination';

export interface NominationForStaff {
  nominationId: number;
  nomination: Nomination;
  qualifications: string[];
  isCaseStudy: boolean;
  isJudged: boolean;
}

export function blankNominationForStaff(): NominationForStaff {
  return {
    nominationId: 0,
    nomination: blankNomination(),
    qualifications: [],
    isCaseStudy: false,
    isJudged: false,
  };
}
